module.exports = __webpack_public_path__ + "img/10.52d8abe0.jpg";